import SimpleClassSpellList from "./SimpleClassSpellList";

export default SimpleClassSpellList;
export { SimpleClassSpellList };
